module.exports = __webpack_public_path__ + "img/Klapplaeden.727f0ba4.jpg";